import { Box, NoSsr } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React from 'react'

import { Theme } from '../../lib/theming/Theme'

const useStyles = makeStyles<Theme>(theme => ({
  card: {
    [theme.breakpoints.down('xs')]: {
      margin: '0.15rem',
    },
    backgroundColor: theme.palette.primary.light,
    borderRadius: '0.25rem',
    color: theme.palette.common.white,
    margin: '0.3rem',
    textAlign: 'center',
  },
  digit: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '2em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.spacing(2.4),
    },
    fontSize: '2.5rem',
    fontVariantNumeric: 'tabular-nums',
    fontWeight: 400,
    lineHeight: 1.5,
    padding: '0.1em 0.4em',
  },
}))

const CountdownCard = (props: { value: string }) => {
  const classes = useStyles()
  const { value } = props

  return (
    <div className={classes.card} data-testid="countdown-card-element">
      <Box className={classes.digit}>
        <NoSsr fallback="&nbsp;">{value}</NoSsr>
      </Box>
    </div>
  )
}

export default CountdownCard
